"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContractorService = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _Api = _interopRequireDefault(require("../Api"));
var _excluded = ["token"],
  _excluded2 = ["token"],
  _excluded3 = ["token"],
  _excluded4 = ["token"],
  _excluded5 = ["token", "id"],
  _excluded6 = ["token", "id"],
  _excluded7 = ["token", "id"],
  _excluded8 = ["token", "id"],
  _excluded9 = ["token", "id"],
  _excluded10 = ["token", "id"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var ContractorService = exports.ContractorService = /*#__PURE__*/(0, _createClass2["default"])(function ContractorService() {
  (0, _classCallCheck2["default"])(this, ContractorService);
});
(0, _defineProperty2["default"])(ContractorService, "list", function (_ref) {
  var token = _ref.token,
    params = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return _Api["default"].withAuth(token).get('/contractor/', {
    params: params
  });
});
(0, _defineProperty2["default"])(ContractorService, "create", function (_ref2) {
  var token = _ref2.token,
    params = (0, _objectWithoutProperties2["default"])(_ref2, _excluded2);
  return _Api["default"].withAuth(token).post('contractor', _objectSpread({}, params));
});
(0, _defineProperty2["default"])(ContractorService, "listContractorTypes", function (_ref3) {
  var token = _ref3.token,
    params = (0, _objectWithoutProperties2["default"])(_ref3, _excluded3);
  return _Api["default"].withAuth(token).get('/contractor/type', {
    params: params
  });
});
(0, _defineProperty2["default"])(ContractorService, "createContractorType", function (_ref4) {
  var token = _ref4.token,
    params = (0, _objectWithoutProperties2["default"])(_ref4, _excluded4);
  return _Api["default"].withAuth(token).post('/contractor/type', _objectSpread({}, params));
});
(0, _defineProperty2["default"])(ContractorService, "editContractorType", function (_ref5) {
  var token = _ref5.token,
    id = _ref5.id,
    params = (0, _objectWithoutProperties2["default"])(_ref5, _excluded5);
  return _Api["default"].withAuth(token).patch("/contractor/type/".concat(id), _objectSpread({}, params));
});
(0, _defineProperty2["default"])(ContractorService, "deleteContractorType", function (_ref6) {
  var token = _ref6.token,
    id = _ref6.id,
    params = (0, _objectWithoutProperties2["default"])(_ref6, _excluded6);
  return _Api["default"].withAuth(token)["delete"]("/contractor/type/".concat(id), _objectSpread({}, params));
});
(0, _defineProperty2["default"])(ContractorService, "enableContractorType", function (_ref7) {
  var token = _ref7.token,
    id = _ref7.id,
    params = (0, _objectWithoutProperties2["default"])(_ref7, _excluded7);
  return _Api["default"].withAuth(token).patch("/contractor/type/".concat(id, "/enable"), _objectSpread({}, params));
});
(0, _defineProperty2["default"])(ContractorService, "disableContractorType", function (_ref8) {
  var token = _ref8.token,
    id = _ref8.id,
    params = (0, _objectWithoutProperties2["default"])(_ref8, _excluded8);
  return _Api["default"].withAuth(token).patch("/contractor/type/".concat(id, "/disable"), _objectSpread({}, params));
});
(0, _defineProperty2["default"])(ContractorService, "edit", function (_ref9) {
  var token = _ref9.token,
    id = _ref9.id,
    params = (0, _objectWithoutProperties2["default"])(_ref9, _excluded9);
  return _Api["default"].withAuth(token).patch("/contractor/".concat(id), _objectSpread({}, params));
});
(0, _defineProperty2["default"])(ContractorService, "editFiles", function (_ref10) {
  var token = _ref10.token,
    id = _ref10.id,
    formData = _ref10.formData;
  return _Api["default"].withAuth(token).patch("/contractor/".concat(id, "/files"), formData);
});
(0, _defineProperty2["default"])(ContractorService, "get", function (_ref11) {
  var token = _ref11.token,
    id = _ref11.id,
    params = (0, _objectWithoutProperties2["default"])(_ref11, _excluded10);
  return _Api["default"].withAuth(token).get("contractor/".concat(id), {
    params: params
  });
});
(0, _defineProperty2["default"])(ContractorService, "delete", function (_ref12) {
  var token = _ref12.token,
    id = _ref12.id;
  return _Api["default"].withAuth(token)["delete"]("contractor/".concat(id));
});